import { useCallback, useState } from 'react';
import { DateSelector, MoreCalculators, Result } from '../../components';
import { getAge } from '../../utils';
import './AgeCalculator.scss';

export const AgeCalculator = () => {
  const [dateOfBirth, setDateOfBirth] = useState(() => new Date('1990-01-01'));
  const [age, setAge] = useState(() => getAge(dateOfBirth));
  const [showLoader, setShowLoader] = useState(false);

  const calculate = useCallback(() => {
    setShowLoader(true);
    setAge(() => getAge(dateOfBirth));
    setTimeout(() => {
      setShowLoader(false);
    }, 1000);
  }, [dateOfBirth]);

  return (
    <>
      <div className='page p-4 rounded border mb-5'>
        <h2>Age Calculator</h2>
        <p className='mb-4'>
          Calculate your age in years, months, weeks, and days
        </p>
        <section className='input border rounded p-4 mb-5'>
          <DateSelector
            label='Select Your Date of Birth'
            initDate={dateOfBirth}
            setDate={setDateOfBirth}
            maxDate={new Date()}
          />
          <button
            className='btn btn-success d-block w-100 py-2 fw-bold'
            onClick={calculate}
          >
            Calculate
          </button>
        </section>
        <Result showLoader={showLoader}>
          <h4>Result:</h4>
          <p className='mb-0'>{age}</p>
        </Result>
      </div>
      <MoreCalculators />
    </>
  );
};
